import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import MaterialTable from '@material-table/core';

import { Col, Form, Row } from 'react-bootstrap';
import { styledTable, years } from '../../../helpers';
import { modifyDefaultOptions } from '../../../helpers/table';
import useAPI from '../../../hooks/useAPI';
import DownloadLink from '../../common/DownloadLink';
import YearSelect from '../../common/YearSelect';
import { getColumns } from './tableHelpers/BudgetReportProj';
import { getDataURL, getExportFileName } from '../../../pages/reports/helpers/budgetReportHelper';
import ProgramBuysTableBuys from '../../../pages/reports/tabsAccounting/ProgramBuysTableBuys';
import ProgramBuysTableKvrs from '../../../pages/reports/tabsAccounting/ProgramBuysTableKvrs';
import './BudgetReportProj.less'

const OPTIONS_VIEW = {
  funding: {
    title: 'По соглашениям',
    getUrl: (entityId) => `/reports/budget/project/${entityId}`,
    fileName: 'Отчет по источникам проекта',
  },
  buys: { title: 'По закупкам', url: '/reports/budget/buys', fileName: 'Отчет по закупкам проекта' },
  // kvr: { title: 'По КВР', url: '/reports/budget/buys/byKvrs', fileName: 'Выгрузка по КВР' },   //"не требуется настраивать для уровня проектов"
  // { value: 'costAgr', label: 'По статьям затрат соглашения' },
};

const OPTIONS_SOURCE = {
  fb: 'Грант',
  sf: 'Софинансирование',
};

export default function BudgetReportProj({ strategyId, originId, num, strategyType }) {
  const api = useAPI();

  const [isLoading, setIsLoading] = useState(false);
  const [selectedView, setSelectedView] = useState('funding');
  const [selectedSource, setSelectedSource] = useState('fb');
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [data, setData] = useState([]);
  const isNew = selectedYear >= 2025 && (strategyType === 'goal' || strategyType === 'tech');

  useEffect(async () => {
    setIsLoading(true);
    const dataURL = getDataURL(
      OPTIONS_VIEW[selectedView].url ?? OPTIONS_VIEW[selectedView].getUrl(originId),
      { year: selectedYear, source: selectedSource, projId: originId },
    );
    const response = await api.get(dataURL);
    if (response && !response.error) {
      setIsLoading(false);
      setData(response);
    } else setData([]);
    setIsLoading(false);
  }, [selectedYear, selectedView, selectedSource]);

  return (
    <>
      <Row className="mb-12">
        <Form.Group as={Col} md="2">
          <Form.Label>Отчетный год </Form.Label>
          <Form.Control
            required
            as="select"
            value={selectedYear}
            onChange={(e) => setSelectedYear((e.target.value))}
          >
            {years.map((year) => <option key={year} value={year}>{year}</option>)}
          </Form.Control>
          <Form.Control.Feedback type="invalid">Выберите год</Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} md="4">
          <Form.Label>
            Представление
          </Form.Label>
          <Form.Control
            required
            as="select"
            value={selectedView}
            onChange={(e) => setSelectedView(e.target.value)}
          >
            {Object.entries(OPTIONS_VIEW).map(([key, view]) => (
              <option key={key} value={key}>
                {view.title}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        {selectedView !== 'funding' && !isNew &&(
          <Form.Group as={Col} md="4">
            <Form.Label>
              Тип финансирования
            </Form.Label>
            <Form.Control
              required
              as="select"
              value={selectedSource}
              onChange={(e) => setSelectedSource(e.target.value)}
            >
              {Object.entries(OPTIONS_SOURCE).map(([key, label]) => (
                <option key={key} value={key}>
                  {label}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        )}
        <Form.Group as={Col}>
          <DownloadLink
            variant="primary"
            type="submit"
            url={getDataURL(OPTIONS_VIEW[selectedView].url ?? OPTIONS_VIEW[selectedView].getUrl(originId), {
              year: selectedYear,
              source: selectedSource,
              projId: originId,
            }, true)}
            filename={getExportFileName(`${OPTIONS_VIEW[selectedView].fileName} ${num}` + ` (${selectedSource === 'fb' ? 'грант' : 'СФ'})`)}
            style={{ marginTop: '30px' }}
          >
            Выгрузить в Excel
          </DownloadLink>
        </Form.Group>
      </Row>
      <Row>
        {
          isLoading && <div className="mt-2">Загрузка...</div>
        }
        {
          selectedView === 'buys' && !isLoading && (
            <ProgramBuysTableBuys data={data} year={selectedYear} sourceType={selectedSource} reportType="onProj" readonly strategyType={strategyType} />
          )
        }
        {
          selectedView === 'kvr' && !isLoading && (
            <ProgramBuysTableKvrs data={data} sourceType={selectedSource} reportType="onProj" />
          )
        }
        {
          selectedView === 'funding' && !isLoading && (
          <div className='budgetReportProjTable' style={styledTable}>
            <MaterialTable
              title={null}
              data={data}
              columns={getColumns()}
              options={modifyDefaultOptions({
                maxBodyHeight: 'calc(100vh - 400px)',
                filtering: false,
                toolbar: false,
                search: false,
                rowStyle: (rowData) => ({
                  fontWeight: !['buy', 'kvr'].includes(rowData.category) ? 'bold' : undefined,
                }),
                headerStyle: {
                  textAlign: 'center',
                  position: 'sticky',
                  zIndex: 1
                },
                defaultExpanded: (rowData) => ['total', 'agreement', 'funding'].includes(rowData.category),
              })}
              parentChildData={(row, rows) =>
                rows.find((a) => a.hash && a.hash === row.parentHash)}
            />
          </div>
          )
        }
      </Row>
    </>
  // <div className="tab-subproject-register" style={{color: 'initial'}}>
  //     <div style={styledContainer}>
  //         <div>
  //             <YearSelect year={year} years={years} onChange={handleYearChange}/>
  //         </div>
  //         <div style={{marginLeft: 16, minWidth: '300px'}}>
  //             <Select options={REPORT_TYPES} defaultValue={REPORT_TYPES[0]} isSearchable={false}/>
  //         </div>
  //         <div style={{marginLeft: 16}}>
  //             <DownloadLink
  //                 variant="outline-primary"
  //                 url={`/reports/budget/project/${originId}/export?year=${year}`}
  //                 filename={`Отчет.xlsx`}
  //             >
  //                 Excel
  //             </DownloadLink>
  //         </div>
  //     </div>
  //
  //     <div style={styledTable}>
  //         <MaterialTable
  //             title={null}
  //             data={data}
  //             columns={getColumns()}
  //             options={modifyDefaultOptions({
  //                 filtering: false,
  //                 search: false,
  //                 rowStyle: rowData => ({
  //                     fontWeight: !['buy', 'kvr'].includes(rowData.category) ? 'bold' : undefined,
  //                 }),
  //                 headerStyle: {textAlign: 'center',},
  //             })}
  //             parentChildData={(row, rows) =>
  //                 rows.find((a) => a.hash && a.hash === row.parentHash)
  //             }
  //         />
  //     </div>
  // </div>
  );
}

const styledContainer = {
  display: 'flex',
  zIndex: 11,
  position: 'relative',
  top: 84,
  width: 670,
  marginTop: -90,
};
